import React from 'react';
import { Segment, Button } from 'semantic-ui-react';
import BusinessPlanTable from '../../BusinessPlanTable';

const BusinessPlans = (props) => {
	let tableRef = React.useRef(null);

	return (
		<div className="animated fadetwoIn padded-top dnp-page">
			<Segment.Group stacked>
				<Segment color='green' className="tableHeaderContainer">
					<div />
					<h2>Business Plans</h2>
					<Button
						onClick={() => {
							if(tableRef && tableRef.current) {
								tableRef.current.refresh();
							}
						}}
						content={<i className="fa fa-refresh fa-lg filterIcon" aria-hidden="true" />}
					/>
				</Segment>
				<Segment placeholder>
					<BusinessPlanTable
						ref={tableRef}
						path="/admin/businessplans"
					/>
				</Segment>
			</Segment.Group>
		</div>
	);
};

export default BusinessPlans;